export var ThemeOptions;
(function (ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
})(ThemeOptions || (ThemeOptions = {}));
// The skins of a theme, format is {baseTheme}-{varientName}
export var ThemeSkin;
(function (ThemeSkin) {
    ThemeSkin["GREEN"] = "light-green";
})(ThemeSkin || (ThemeSkin = {}));
//# sourceMappingURL=constants.js.map